import React from 'react';

type Props = {
  randomString: string;
};
/**
 * Returns an iframe, Should only re-render if props change and it shouldn't
 * Hopefully prevents multiple login counts.
 *
 * @returns React.JSX.Element
 */
const LoginIframe = React.memo(function LoginIframe(props: Props) {
  const { randomString } = props;

  return (
    <iframe
      id="login-iframe"
      title="login"
      width="100%"
      height="322px"
      src={`${import.meta.env.VITE_LOGIN_URL}&state=${randomString}`}
      sandbox="allow-same-origin allow-top-navigation allow-scripts allow-forms"
    ></iframe>
  );
});

export default LoginIframe;
